import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import * as fromTicketsState from '@resident-nx/shared';
import {
  getArchiveTicketActionState,
  TicketingVersion,
  TicketsOverviewArchivedBaseComponent,
  getSelectedContract,
  getTicketSorting,
  getUnread,
} from '@resident-nx/shared';
import { combineLatest, map, take, tap } from 'rxjs';
import { ArchiveTicketsCardWebComponent } from '../archive-tickets-card/archive-tickets-card.component';
import { TicketsWebComponent } from '../tickets/tickets.component';
@Component({
  standalone: true,
  selector: 'rs-web-tickets-overview-archived',
  imports: [ArchiveTicketsCardWebComponent, AsyncPipe, TicketsWebComponent, TranslateModule],
  templateUrl: './tickets-overview-archived.component.html',
  styleUrl: './tickets-overview-archived.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketsOverviewArchivedWebComponent
  extends TicketsOverviewArchivedBaseComponent
  implements OnInit
{
  #destroyRef = inject(DestroyRef);
  #unread = this.masterDataStore.selectSignal(getUnread);
  #selectedContract = this.masterDataStore.selectSignal(getSelectedContract);
  protected readonly hasUnreadArchived = computed(() => {
    const unread = this.#unread()?.unreadTicketMessages;
    return (
      !!unread?.archivedContractless ||
      !!unread?.archivedContractIds?.includes(this.#selectedContract()?.id)
    );
  });
  public isArchiving$ = this.ticketsStore
    .select(getArchiveTicketActionState)
    .pipe(map(state => state?.pending === true));

  override ngOnInit(): void {
    super.ngOnInit();
    combineLatest([
      this.masterDataStore.select(getSelectedContract),
      this.masterDataStore.select(getTicketSorting),
    ])
      .pipe(
        tap(([_, sort]) => {
          this.sort = sort;

          this.ticketingVersion$.pipe(take(1)).subscribe(version => {
            if (this.archiveType === 'damage') {
              if (version === TicketingVersion.HIERARCHICAL) {
                this.ticketsStore.dispatch(
                  fromTicketsState.LoadArchiveDamageTicketsForSelectedContractHQ({
                    ...this.pagination,
                    sort: this.sort,
                  })
                );
              } else if (version === TicketingVersion.METADATA) {
                this.ticketsStore.dispatch(
                  fromTicketsState.LoadArchiveDamageTicketsForSelectedContract({
                    ...this.pagination,
                    sort: this.sort,
                  })
                );
              }
            } else if (this.archiveType === 'request') {
              if (version === TicketingVersion.HIERARCHICAL) {
                this.ticketsStore.dispatch(
                  fromTicketsState.LoadArchiveRequestTicketsForSelectedContractHQ({
                    ...this.pagination,
                    sort: this.sort,
                  })
                );
              } else if (version === TicketingVersion.METADATA) {
                this.ticketsStore.dispatch(
                  fromTicketsState.LoadArchiveRequestTicketsForSelectedContract({
                    ...this.pagination,
                    sort: this.sort,
                  })
                );
              }
              this.txtNoTickets = 'archive_request.no_data';
            }
          });
        }),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe();
  }
}
